import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_URL,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('swisstime_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('swisstime_token');
            localStorage.removeItem('swisstime_user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const authAPI = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    getMe: () => api.get('/auth/me'),
};

export const projectsAPI = {
    getAll: () => api.get('/projects'),
    getOne: (id) => api.get(`/projects/${id}`),
    create: (data) => api.post('/projects', data),
    update: (id, data) => api.put(`/projects/${id}`, data),
    delete: (id) => api.delete(`/projects/${id}`),
};

export const tasksAPI = {
    getAll: (projectId = null) => api.get('/tasks', { params: { project_id: projectId } }),
    create: (data) => api.post('/tasks', data),
    update: (id, data) => api.put(`/tasks/${id}`, data),
    delete: (id) => api.delete(`/tasks/${id}`),
};

export const teamMembersAPI = {
    getAll: () => api.get('/team-members'),
    create: (data) => api.post('/team-members', data),
    update: (id, data) => api.put(`/team-members/${id}`, data),
    delete: (id) => api.delete(`/team-members/${id}`),
};

export const timeEntriesAPI = {
    getAll: () => api.get('/time-entries'),
    create: (data) => api.post('/time-entries', data),
    delete: (id) => api.delete(`/time-entries/${id}`),
};

export const reportsAPI = {
    getSummary: () => api.get('/reports/summary'),
    exportData: () => api.get('/reports/export'),
    importData: (data) => api.post('/reports/import', data),
    // Download xlsx — must use responseType: 'arraybuffer' for binary file
    downloadXlsx: ({ project_id, date_from, date_to }) =>
        api.get('/reports/excel', {
            params: { project_id, date_from, date_to },
            responseType: 'arraybuffer',
        }),
};

export const dashboardAPI = {
    getStats: () => api.get('/dashboard/stats'),
};

export default api;
